
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.167 5.637h-5a.833.833 0 100 1.667h1.266L7.767 13.97H5.833a.833.833 0 100 1.667h5a.833.833 0 000-1.667H9.567l2.666-6.666h1.934a.833.833 0 000-1.667z","fill":"#000C1F"}})])
          )
        }
      }
    